module.exports = __webpack_public_path__ + "media/src/images/icons/print/primary-fcc7a8e91eedc23add1a28058a30a6dc.svg";